import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Mega Pack después de comprar?',
  a: 'Recibirás el acceso al material de forma inmediata para que puedas empezar a usarlo hoy mismo, sin esperas ni trámites.'
}, {
  q: '¿Para qué nivel educativo está pensado?',
  a: 'El Mega Pack está diseñado para docentes de secundaria, preparatoria y nivel universitario que enseñan Historia de México. El lenguaje es claro y el material puede adaptarse a distintos niveles de profundidad según tu grupo.'
}, {
  q: '¿Sirve para cualquier país hispanohablante?',
  a: 'El contenido está centrado en la historia de México. Es ideal para docentes mexicanos o para profesores de cualquier país hispanohablante que enseñen historia de México o historia latinoamericana comparada.'
}, {
  q: '¿El material es editable?',
  a: 'El material se entrega en formato PDF listo para usar. No requiere edición — está pensado para que puedas usarlo directamente en el aula sin trabajo previo de adaptación.'
}, {
  q: '¿En qué moneda voy a pagar?',
  a: 'Pagas en tu moneda local. El importe se adapta automáticamente al país desde donde realizas la compra.'
}, {
  q: '¿Qué incluye la oferta especial de USD 27,90?',
  a: 'Incluye el Mega Pack Historia México 360 completo — los 7 tomos más los 5 bonos — más el Pack Maestro Avanzado con 5 tomos de historia universal conectada directamente con los períodos de la historia de México. Es el pack más completo disponible.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tienes 7 días de garantía total. Si el material no cumple lo que prometemos, te devolvemos el 100% de tu dinero sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-ivory" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <div className="text-center mb-16" data-id="element-81">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-forest" data-id="element-82">
            ❓ Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-83">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-beige rounded-xl overflow-hidden shadow-sm" data-id="element-84">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-85">
                <span className="font-bold text-lg text-ink pr-8" data-id="element-86">{faq.q}</span>
                <ChevronDown className={`text-terracotta transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-87" />
              </button>

              <AnimatePresence data-id="element-88">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-89">
                    <div className="px-6 pb-5 text-warmgray font-medium border-t border-beige/50 pt-4" data-id="element-90">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}